/**
 * TK-37 việc 1 (23/10/2026) — nút "Nháy" nhận diện MỘT đèn (người cài đứng dưới cột nhìn đèn nào chớp).
 *   Một component cho các chỗ: khung chi tiết đèn (tab Đèn của trang tủ), ô đèn / popup chấm đèn trên bản đồ.
 *   · Gửi `kind='nhay'`, `addrs` đúng 1 đèn. Tủ làm 100 → 10 × 3 rồi tự trả mức cũ — web không gửi mức nào.
 *   · Khoá-không-ẩn: luôn bọc `<KhoaTheoTuyen co="canControl">` (nhận `qd` ba ca, không nhận boolean).
 *   · TK-44 (lee 24/10): chỉ bấm được khi đèn NHẬN lệnh — máy chủ tính `lyDo` (tủ mất kết nối · mesh tắt · ngõ ra tắt · đèn mất liên
 *     lạc); nơi gọi truyền chữ ngắn (`chuLyDo`) ⇒ nút mờ + chữ ấy (xám). Máy chủ cũng chặn (409).
 */
import { Button, useToast } from '../ui';
import { KhoaTheoTuyen } from '../Khoa';
import { errorMessage } from '../../lib/api';
import type { QuyetDinhCoTuyen } from '../../lib/quyen';
import { useGuiLenhNema } from '../../lib/nemaApi';

export function NutNhay({ cabinetId, addr, ten, khoaVi, qd, trungTinh = false, hienLyDo = true }: {
  cabinetId: string; addr: number; ten: string;
  /** lý do đèn không nhận lệnh (chữ ngắn); null = nhận được */
  khoaVi: string | null;
  qd: QuyetDinhCoTuyen | 'khong-co-tuyen' | 'chua-biet';
  /** khung khoá viền trung tính (ô đèn trang Vận hành) */
  trungTinh?: boolean;
  /** TK-46 §2: ô đèn đã nói lý do (chip / "Chưa có số đo · …") ⇒ không lặp chữ cạnh nút */
  hienLyDo?: boolean;
}) {
  const gui = useGuiLenhNema(cabinetId);
  const toast = useToast();
  const nhay = () => gui.mutate({ kind: 'nhay', addrs: [addr] }, {
    onSuccess: (l) => toast.success(l.state === 'CHO_GIAO_THUC' ? `Nháy ${ten} — chờ giao thức tủ` : `Nháy ${ten} — đã gửi`),
    onError: (e) => toast.error(`Nháy ${ten} — không gửi được`, errorMessage(e)),
  });
  return (
    <KhoaTheoTuyen qd={qd} co="canControl" hienHuyHieu={false} trungTinh={trungTinh}>
      <span className="inline-flex items-center gap-1.5" data-o="nut-nhay" data-khoa={khoaVi ? '1' : undefined}>
        <Button size="sm" variant="secondary" className="min-h-[44px] min-w-[64px]"
          disabled={qd !== 'cho-qua' || !!khoaVi || gui.isPending} onClick={nhay}>Nháy</Button>
        {khoaVi && hienLyDo && <span className="text-xs text-chu-3">{khoaVi}</span>}
      </span>
    </KhoaTheoTuyen>
  );
}
